module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "center "
  }, [_vm._v("First U.S. edition")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("First Mariner Books edition 2017")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2015 by Sara Baume")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Reading Group Guide Questions and Discussion Points copyright © 2017 by Houghton Mifflin Harcourt Publishing Company")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Q&A with Author copyright © 2017 by Sara Baume")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover design © Suzanne Dean")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Cover illustration based on an etching by Helen Fay")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Author photograph © Patrick Bolger")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("First published in the Republic of Ireland by Tramp Press in 2015")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data:")]), _c('br'), _vm._v("\nNames: Baume, Sara, author.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Title: Spill simmer falter wither / Sara Baume.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Description: First U.S. edition. | Boston : Houghton Mifflin Harcourt, 2016."), _c('br'), _vm._v("\n2015 Identifiers: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2015037012 | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780544716193 (hardcover) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780544716223 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780544954618 (pbk.)"), _c('br'), _vm._v("\nSubjects: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCSH:")]), _vm._v(" Human-animal relationships—Fiction. Dog owners—Fiction."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BISAC: FICTION")]), _vm._v(" / Literary. | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FICTION")]), _vm._v(" / General."), _c('br'), _vm._v("\nClassification: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC")]), _vm._v(" PR6102.A86 S65 2016 | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDC")]), _vm._v(" 823/.92—dc23"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    attrs: {
      "href": "http://lccn.loc.gov/2015037012",
      "target": "_blank"
    }
  }, [_vm._v("http://lccn.loc.gov/2015037012")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("v3.0217")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0